import {Pipe, PipeTransform} from "@angular/core";
import {BusinessI18nService} from "@core/libs";
import {DecimalPipe} from "@angular/common";
import {map, Observable} from "rxjs";
import {castInt} from "@shared/utils";


type DecimalOpts = {
  minFractionDigits?: number,
  maxFractionDigits?: number,
  notSuffix?: boolean
}

@Pipe({
  name: 'percentDecimalI18n',
  standalone: false
})
export class PercentDecimalI18nPipe implements PipeTransform {

  constructor(
    private decimalPipe: DecimalPipe,
    private businessI18nService: BusinessI18nService,
  ) {

  }

  transform(value: any, opts?: DecimalOpts): Observable<string | null> {
    return this.businessI18nService.configs$.pipe(
      map(configs => {
        if (!this.isValidNumber(value)) {
          return null;
        }

        /**
         * Mặc định lấy 2 số thập phân, cân nhắc có thể lấy theo cài đặt của DN nếu cho thêm cài đặt
         * */
          // const digitsInfo: string | undefined = `1.0-2`;
        const digitsInfo = `1.0-${castInt(configs.percentDecimals)}`;

        const result = this.decimalPipe.transform(value, digitsInfo, configs.locale);

        let suffix = '%';
        if (opts && opts.notSuffix) {
          suffix = '';
        }

        return `${result}${suffix}`;
      })
    )
  }

  private isValidNumber(value: any): boolean {
    return typeof value === 'number' && !isNaN(value) ||
      (typeof value === 'string' && !isNaN(parseFloat(value)));
  }
}
